/**
 * Created by Vladislav on 05.09.2024.
 */

Object.assign(VirtualProducts, {
    stickers0: {
        title: "StickersBook.products.specialPack",
        currency: "hard",
        spentEvent: cleverapps.EVENTS.SPENT.STICKERS_3,
        price: RewardsConfig.stickers0.hardPrice,
        icon: bundles.stickers_shop.frames.stickers_chest_0,
        availableAfterCollection: 2,
        reward: RewardsConfig.stickers0.reward
    },

    stickers1: {
        title: "StickersBook.products.mediumPack",
        currency: "hard",
        spentEvent: cleverapps.EVENTS.SPENT.STICKERS_2,
        price: RewardsConfig.stickers1.hardPrice,
        icon: bundles.stickers_shop.frames.stickers_chest_1,
        reward: RewardsConfig.stickers1.reward
    },

    stickers2: {
        title: "StickersBook.products.smallPack",
        currency: "hard",
        spentEvent: cleverapps.EVENTS.SPENT.STICKERS_1,
        price: RewardsConfig.stickers2.hardPrice,
        icon: bundles.stickers_shop.frames.stickers_chest_2,
        reward: RewardsConfig.stickers2.reward
    }
});
